import React, { useEffect } from "react";
import Api from "../../Utils/Api";
import Storelist from "../../Store/Actions";
import { CloseOutlined, UploadOutlined } from "@ant-design/icons";
import { Modal, Button, Form, Input, Select, Upload } from "antd";
import { roles } from "../../appconfig";
import Swal from "sweetalert2";

const AddTechnician = () => {
  const { CreateRequestDetailsStore, PageStore, setAddTechnician, setLoading } =
    Storelist();

  const { AddSuperStar } = Api();

  const formData = new FormData();

  const [form] = Form.useForm();

  const handleChange = (name, e) => {
    // allow only digits, max 10
    const digits = e.target.value.replace(/\D/g, "").slice(0, 10);
    console.log(typeof Number(digits));
    // update form field
    form.setFieldsValue({ [name]: Number(digits) });
  };

  const handlePaste = (name, e) => {
    e.preventDefault();
    const paste = (e.clipboardData || window.clipboardData).getData("text");
    const digits = paste.replace(/\D/g, "").slice(0, 10);
    console.log(typeof Number(digits));
    form.setFieldsValue({ [name]: Number(digits) });
  };

  useEffect(() => {
    if (!PageStore?.is_add_technician) {
      form.resetFields();
    }
  }, [PageStore?.is_add_technician]);

  const onFinish = (values) => {
    // console.log(values);
    setLoading(true);
    formData.append("name", values?.name);
    if(values.email){
      formData.append("emailId", values?.email);
    }
    formData.append("mobileNumber", values?.phoneNumber);
    formData.append("emergencyPhone", values?.emergencyContact);
    formData.append("employeeId", values?.employeeId);
    formData.append("role", values?.role);
    formData.append("branch", values?.branch);
    if(values?.profileImage){
      formData.append("profile", values?.profileImage[0]?.originFileObj);
    }
    if (values?.aadharCard) {
      formData.append("adhaar", values?.aadharCard[0]?.originFileObj);
    }
    if (values?.drivingLicense) {
      formData.append(
        "drivingLicense",
        values?.drivingLicense[0]?.originFileObj
      );
    }

    AddSuperStar(formData);
  };

  return (
    <Modal
      closeIcon={
        <CloseOutlined
          style={{
            border: "1px solid black",
            borderRadius: "10px",
            padding: "4px",
            color: "black",
            fontSize: "18px",
            backgroundColor: "white",
          }}
        />
      }
      maskClosable={false}
      keyboard={false}
      onCancel={() => {
        setAddTechnician(false);
        form.resetFields();
      }}
      open={PageStore?.is_add_technician}
      footer={null}
      //   destroyOnHidden
    >
      <div className="w-[100%] h-[100%]  border ">
        <div className="text-center text-xl font-semibold">Add Superstar</div>

        <Form
          layout={"vertical"}
          form={form}
          initialValues={{ layout: "vertical" }}
          onFinish={onFinish}
          style={{
            maxWidth: "vertical" === "inline" ? "none" : "80%",
            marginLeft: "10%",
          }}
          className=" w-[100%]"
          requiredMark={false}
        >
          <Form.Item
            label={
              <span>
                Name <span style={{ color: "red" }}>*</span>
              </span>
            }
            name={"name"}
            rules={[{ required: true, message: "Please input your username!" }]}
          >
            <Input placeholder="Enter Employee Full Name" />
          </Form.Item>

          <Form.Item
            label={
              <span>
                Email Id 
              </span>
            }
            name={"email"}
            rules={[
              // { required: true, message: "Please enter Employee email" },
              {
                type: "email",
                message: "Please enter a valid email address",
              },
            ]}
          >
            <Input
              label="Email"
              placeholder="Enter Employee Email"
              name="email"
            />
          </Form.Item>

          <Form.Item
            label={
              <span>
                Phone Number <span style={{ color: "red" }}>*</span>
              </span>
            }
            name={"phoneNumber"}
            rules={[
              { required: true, message: "Please input Phone Number" },
              {
                pattern: /^\d{10}$/, // regex → exactly 10 digits
                message: "Phone number must be exactly 10 digits",
              },
            ]}
          >
            <Input
              style={{ width: "100%" }}
              controls={false}
              placeholder="Enter Employee phonenumber"
              onChange={(e) => {
                handleChange("phoneNumber", e);
              }}
              onPaste={handlePaste}
            />
          </Form.Item>

          <Form.Item
            label={
              <span>
                Emergency Contact <span style={{ color: "red" }}>*</span>
              </span>
            }
            name={"emergencyContact"}
            rules={[
              { required: true, message: "Please input Phone Number" },
              {
                pattern: /^\d{10}$/,
                message: "Phone number must be exactly 10 digits",
              },
            ]}
          >
            <Input
              style={{ width: "100%" }}
              controls={false}
              placeholder="Enter Employee Emergency Contact"
              onChange={(e) => {
                handleChange("emergencyContact", e);
              }}
              onPaste={handlePaste}
            />
          </Form.Item>

          <Form.Item
            label={
              <span>
                Employee ID<span style={{ color: "red" }}>*</span>
              </span>
            }
            name={"employeeId"}
            rules={[{ required: true, message: "Please input Employee ID" }]}
          >
            <Input placeholder="Enter Employee ID" />
          </Form.Item>

          <Form.Item
            label="Branch"
            name={"branch"}
            initialValue={CreateRequestDetailsStore?.branchDetail?._id}
            rules={[{ required: true, message: "Please input Branch" }]}
          >
            <Select>
              <Select.Option
                value={CreateRequestDetailsStore?.branchDetail?._id}
              >
                {CreateRequestDetailsStore?.branchDetail?.branchName}
              </Select.Option>
            </Select>
          </Form.Item>

          <Form.Item
            label={
              <span>
                Role<span style={{ color: "red" }}>*</span>
              </span>
            }
            name={"role"}
            rules={[{ required: true, message: "Please input Employee ID" }]}
          >
            <Select placeholder="select role">
              {roles?.map((item,index) => (
                <Select.Option key={index} value={item.id}>{item.role}</Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label={
              <span>
                Profile Image
              </span>
            }
            name="profileImage"
            valuePropName="fileList"
            getValueFromEvent={(e) => {
              // e is the Upload event
              if (Array.isArray(e)) return e;
              return e?.fileList;
            }}
            // rules={[{ required: true, message: "Profile Image Required!" }]}
          >
            <Upload.Dragger
              beforeUpload={(file) => {
                const isImage = file.type.startsWith("image/");
                if (!isImage) {
                  return Upload.LIST_IGNORE;
                }
                return false;
              }}
              accept="image/*"
              maxCount={1}
            >
              <p className="ant-upload-drag-icon">
                <UploadOutlined />
              </p>
              <p className="ant-upload-text">
                Click or drag file to this area to upload
              </p>
            </Upload.Dragger>
          </Form.Item>

          <Form.Item
            label="Aadhar    Card"
            name="aadharCard"
            valuePropName="fileList"
            getValueFromEvent={(e) => {
              if (Array.isArray(e)) return e;
              return e?.fileList;
            }}
          >
            <Upload.Dragger
              beforeUpload={(file) => {
                const isImage = file.type.startsWith("image/");
                if (!isImage) {
                  return Upload.LIST_IGNORE;
                }
                return false;
              }}
              maxCount={1}
            >
              <p className="ant-upload-drag-icon">
                <UploadOutlined />
              </p>
              <p className="ant-upload-text">
                Click or drag file to this area to upload
              </p>
            </Upload.Dragger>
          </Form.Item>

          <Form.Item
            label="Driving License"
            name="drivingLicense"
            valuePropName="fileList"
            getValueFromEvent={(e) => {
              // e is the Upload event
              if (Array.isArray(e)) return e;
              return e?.fileList;
            }}
          >
            <Upload.Dragger
              beforeUpload={(file) => {
                const isImage = file.type.startsWith("image/");
                if (!isImage) {
                  return Upload.LIST_IGNORE;
                }
                return false;
              }}
              maxCount={1}
              accept="image/*"
              multiple={false}
            >
              <p className="ant-upload-drag-icon">
                <UploadOutlined />
              </p>
              <p className="ant-upload-text">
                Click or drag file to this area to upload
              </p>
            </Upload.Dragger>
          </Form.Item>

          <Form.Item className=" flex justify-center">
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default AddTechnician;
